import './index.css'
import { useEffect, useMemo, useState } from 'react'
import PostLogin from 'shared/api/endpoints/authorization/Post_Login'
import NotificationFeature from 'features/notification'
import { Button, Input, ToggleTheme } from '@office/ui-kit'
import useNotification from 'shared/hooks/useNotification'

function App() {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)

  const { html_notification } = useNotification()

  const themes = useMemo(() => ['dark', 'default'], [])

  const useQuery = () => new URLSearchParams(window.location.search)
  const referrer = useQuery().get('referrer')
  const queryTheme = useQuery().get('theme')

  function authHandler() {
    if (login.trim() === '' || password.trim() === '') {
      return setError('Одно из полей пустое')
    }

    PostLogin({
      login: login,
      password: password,
    })
      .then((res) => {
        if (res.status === 200 && referrer) {
          if (
            referrer.endsWith('office.gkregion72.ru') ||
            /^(.*)office.gkregion72.ru:(.*)/.test(referrer) ||
            /^(.*)office.gkregion72.ru[/](.*)/.test(referrer) ||
            (process.env.REACT_APP_ENVIRONMENT === 'development' &&
              /^(.*)localhost(.*)/.test(referrer))
          ) {
            // eslint-disable-next-line
            return location.replace(
              `${referrer}?token=${res.data.token}&refresh=${res.data.refresh}`,
            )
          }
          return setError('Невалидная ссылка')
        } else if (res.status === 200 && !referrer) {
          return setError('Ошибка перенаправления')
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          return setError('Неправильный логин или пароль')
        }
        if (err.code === 'ERR_NETWORK') {
          return setError('Ошибка соединения с сервером')
        }

        return setError('Ошибка сервера')
      })
  }

  function keyHandler(e) {
    if (e.key === 'Enter') {
      authHandler()
    } else if (error !== null) {
      setError(null)
    }
  }

  const html = document.getElementsByTagName('html')
  function toggleTheme() {
    if (localStorage.getItem('theme') === 'default') {
      localStorage.setItem('theme', 'dark')

      return html[0].setAttribute('saved-theme', 'dark')
    } else {
      localStorage.setItem('theme', 'default')
      return html[0].setAttribute('saved-theme', 'default')
    }
  }

  useEffect(() => {
    if (localStorage.getItem('theme') === 'dark') {
      html[0].setAttribute('saved-theme', 'dark')
    } else {
      html[0].setAttribute('saved-theme', 'default')
    }
    if (!localStorage.getItem('theme') && !queryTheme) {
      return localStorage.setItem('theme', 'dark')
    }
    return
  })

  useEffect(() => {
    if (error) {
      return html_notification({
        title: error,
        text: error,
        timeout: 10,
        type: Notification.error,
      })
    }
    // eslint-disable-next-line
  }, [error])

  useEffect(() => {
    if (window.location.search) {
      const URLArguments = JSON.parse(
        '{"' +
          decodeURI(
            window.location.search.slice(1).replace(/&/g, '","').replace(/=/g, '":"'),
          ) +
          '"}',
      )
      if (themes.includes(URLArguments.theme)) {
        return localStorage.setItem('theme', URLArguments.theme)
      }
    }

    if (!themes.includes(localStorage.getItem('theme') || '')) {
      return localStorage.setItem('theme', 'dark')
    }
  }, [themes, referrer])

  return (
    <div className="page" onKeyDown={(e) => keyHandler(e)}>
      <form className="login-form">
        <div className="login-form__container">
          <div className="login-form-logo">
            <img src={require('./logo.png')} alt="" />
          </div>
          <div className="login-form-nickname">
            <div className="login-form-nickname__input">
              <Input
                setValue={setLogin}
                value={login}
                placeholder="Логин"
                form="default"
                error={error}
                tab={1}
              />
            </div>
          </div>

          <div className="login-form-password">
            <div className="login-form-password__input">
              <Input
                setValue={setPassword}
                value={password}
                placeholder="Пароль"
                type="password"
                error={error}
                tab={2}
              />
            </div>
          </div>

          <div className="login-button">
            <Button
              form="ellipse"
              tab={3}
              title="Войти"
              handler={() => {
                authHandler()
              }}
            ></Button>
          </div>
        </div>
      </form>

      <div className="switch-theme">
        <div className="switch-theme__text">
          <p>Сменить тему</p>
        </div>
        <div className="switch-theme__toggle">
          <ToggleTheme
            toggle_action={toggleTheme}
            toggle_state={localStorage.getItem('theme') === 'dark' ? true : false}
          />
        </div>
      </div>

      <NotificationFeature />
    </div>
  )
}

export default App
